import React from "react";
import HeroBanner from "components/sections/HeroBanner";
import OurVision from "components/sections/OurVision";
import { OUR_GOALs_DATA } from "config/data";
import CompanyValues from "components/sections/CompanyValues";
import Counter from "components/sections/Counter";
import Testimonals from "components/sections/Testimonals";
import { Container } from "react-bootstrap";
import HallofFame from "components/sections/HallofFame";

const AboutPage = () => {
  return (
    <>
      <HeroBanner
        title="About Us"
        subTitle="Who We Are & What We Do"
        desc="Discover our journey, values, and commitment to delivering exceptional solutions."
      />
      <OurVision />
      <Counter />
      <Container>
        <div className="industries-section row">
          {OUR_GOALs_DATA.map((industry, index) => (
            <div key={index} className="industries-serving col-md-4 !py-8">
              <span className="industry-icon">
                <img className="h-16" src={industry.img} alt={industry.title} />
              </span>
              <h6>{industry.title}</h6>
              <p>{industry.desc}</p>
            </div>
          ))}
        </div>
      </Container>
      <CompanyValues />
      <Testimonals />
      <HallofFame />
    </>
  );
};

export default AboutPage;
